import { Link } from "react-router-dom";
import { pandianList } from "@/mocks/pandian";

export default function PandianSection() {
  return (
    <section className="mx-auto max-w-container px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">同类盘点</span>
          <h2 className="mt-2 text-2xl text-foreground-950 md:text-3xl">一锅端：把同类的瓜都给你归好类</h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            塌房姿势、道歉模板、综艺剪辑套路……把多年相似剧情归拢成一张图谱，一次看透行业规律。
          </p>
        </div>
        <Link to="/pandian" className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-400">
          进入盘点库 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {pandianList.slice(0, 3).map((p) => (
          <Link
            key={p.id}
            to="/pandian"
            className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition hover:-translate-y-1 hover:border-primary-300"
          >
            <div className="flex items-center justify-between">
              <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs ${p.tone}`}>
                <i className={p.icon}></i>
                {p.tag}
              </span>
              <span className="text-xs text-foreground-400">{p.span}</span>
            </div>
            <h3 className="mt-4 text-base font-semibold leading-snug text-foreground-950 transition group-hover:text-primary-600">
              {p.title}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600 line-clamp-2">{p.lead}</p>
            <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-database-2-line text-primary-500"></i>
                {p.count}
              </span>
              <span className="flex items-center gap-1 text-sm font-medium text-primary-600">
                展开盘点 <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}